export default interface User {
  email: string 
  shouldUpdatePassword: boolean
}

export const ADMIN = 'administrator'
export const CLIENT = 'client'
export const VENDOR = 'vendor'
export const STAFF = 'staff'
export const HEADSALES = 'headsales'
export const MANAGER = 'manager'
export const PERSON = 'person'

export type Role = typeof ADMIN | typeof CLIENT | typeof VENDOR | typeof STAFF | typeof HEADSALES | typeof MANAGER | typeof PERSON